<mat-dialog-content>
    <app-e-form-viewer [configInput]="config"></app-e-form-viewer>
</mat-dialog-content>

<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button image="previous arrow.png" disabledImage="previous arrow disabled.png" label="Previous"
            (clickEvent)="previousClick()" [disabled]="isFP" *ngIf="showNextPreviousButtons"></tyl-button>
    </div>
    <div class="flex-footer-middle">
        
    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="next arrow.png" disabledImage="next arrow disabled.png" label="Next" (clickEvent)="nextClick()" [disabled]="isLP" *ngIf="showNextPreviousButtons"></tyl-button>
        <tyl-button image="print.png"  label="Print" (clickEvent)="printClick()"></tyl-button>
        <!-- <tyl-button image="save.png" label="Save" (clickEvent)="saveClick();validationTrigger.click();"></tyl-button> -->
        <tyl-button image="cancel.png" [label]="'Close'" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>

<input style="display:none" type="submit" form="vForm" #validationTrigger>